import React, { useState, useEffect } from "react";
import logo from "./assets/logo.png";

const questions = [
  "How long have you been using module-X?",
  "How easy is it to navigate the module-X?",
  "Have you experienced any difficulties learning how to use it?",
  "What features do you find most useful?",
  "What features do you find least useful or confusing?",
  "How reliable is the module-X?",
  "How would you rate its speed and responsiveness?",
  "How well does module-X integrate with other systems you use?",
  "Have you used any IPPIS module help or support resources?",
  "Were those support resources effective?",
  "How satisfied are you with the level of the available support?",
  "How has the module-X impacted your work or productivity?",
  "What value does it bring to your organization or workflow?",
  "What new features or enhancements would you like to see?",
  "Any final thoughts or feedback?",
];

function ArrowRight() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M3 8h10M9 4l4 4-4 4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ArrowLeft() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M13 8H3M7 4L3 8l4 4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function CheckIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
      <path
        d="M6 14l6 6 10-12"
        stroke="#2e7d5e"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SurveyInterviewQuestionForm() {
  const [step, setStep] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [modules, setModules] = useState([]);
  const [form, setForm] = useState({
    phone: "",
    position: "",
    institution: "",
    module: "",
    answers: Array(questions.length).fill(""),
  });

  useEffect(() => {
    const fetchModules = async () => {
      try {
        const res = await fetch("/api/support/categories"); // <-- your modules API
        if (!res.ok) return;

        const data = await res.json();

        // Expecting array like:
        // [{ id:1, moduleName:"Payroll" }, ...]
        setModules(data || []);
      } catch (err) {
        console.error("Modules fetch error:", err);
      }
    };

    fetchModules();
  }, []);

  const handleChange = async (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    if (field === "phone") {
      const digits = value.replace(/\D/g, "");

      if (digits.length === 10) {
        try {
          const res = await fetch("/api/support/employeeDetails", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ phoneNumber: digits }),
          });

          if (!res.ok) return;

          const data = await res.json();

          if (data && data.length > 0) {
            const user = data[0];

            setForm((prev) => ({
              ...prev,
              position: user.PositionName || "",
              institution: user.InstitutionName || "",
            }));
          }
        } catch (err) {
          console.error("Profile fetch error:", err);
        }
      }
    }
  };
  const handleAnswerChange = (value) => {
    setForm((prev) => {
      const updated = [...prev.answers];
      updated[step - 1] = value;
      return { ...prev, answers: updated };
    });
  };

  const next = () => {
    if (step < questions.length) setStep((s) => s + 1);
  };
  const back = () => {
    if (step > 0) setStep((s) => s - 1);
  };

  const progress = (step / (questions.length + 1)) * 100;

  const handleSubmit = () => {
    console.log("Survey submitted:", form);
    setSubmitted(true);
  };

  const canProceedProfile =
    form.phone.trim() !== "" &&
    form.position.trim() !== "" &&
    form.institution.trim() !== "" &&
    form.module.trim() !== "";

  const moduleName = form.module || "the module";

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@500;700&family=DM+Sans:wght@300;400;500&display=swap');
        @keyframes fadeUp { from { opacity:0; transform:translateY(20px); } to { opacity:1; transform:translateY(0); } }
        body { margin:0; min-height:100vh; display:flex; align-items:center; justify-content:center; padding:2rem; background:#faf8f5; box-sizing:border-box; }
      `}</style>

      {/* Page wrapper */}
      <div
        style={{
          width: "100%",
          maxWidth: 680,
          fontFamily: "'DM Sans', sans-serif",
          animation: "fadeUp 0.5s ease both",
        }}
      >
        {/* ── Dark header band ── */}
        <div
          style={{
            background: "rgba(10,46,82,1)",
            borderRadius: "16px 16px 0 0",
            padding: "2rem 2.5rem",
            display: "flex",
            alignItems: "flex-start",
            gap: "1.25rem",
            overflow: "hidden",
          }}
        >
          <img
            src={logo}
            alt="Logo"
            style={{
              width: 36,
              height: 36,
              flexShrink: 0,
              filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))",
            }}
          />
          <div style={{ flex: 1 }}>
            <div
              style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: "1.45rem",
                color: "#ffffff",
                fontWeight: 700,
                lineHeight: 1.2,
                marginBottom: "0.35rem",
              }}
            >
              IPPIS USER IN-DEPTH INTERVIEW 
            </div>
            <div
              style={{
                fontSize: "0.82rem",
                color: "rgba(255,255,255,0.55)",
                fontWeight: 300,
                letterSpacing: "0.04em",
                textTransform: "uppercase",
              }}
            >
              MIFOTRA · IPPIS System Evaluation
            </div>
          </div>
        </div>

        {/* ── Gold progress bar ── */}
        <div style={{ height: 3, background: "#dde3e8" }}>
          <div
            style={{
              height: 3,
              width: `${submitted ? 100 : progress}%`,
              background: "linear-gradient(90deg, #c9973a, #e8b85a)",
              transition: "width 0.4s ease",
            }}
          />
        </div>

        {/* ── White card body ── */}
        <div
          style={{
            background: "#ffffff",
            borderRadius: "0 0 16px 16px",
            padding: "2.5rem",
            boxShadow:
              "0 2px 8px rgba(15,25,35,0.07), 0 12px 40px rgba(15,25,35,0.1)",
          }}
        >
          {submitted ? (
            // ── Thank-you screen ──
            <div style={{ textAlign: "center", padding: "2rem 0" }}>
              <div
                style={{
                  width: 64,
                  height: 64,
                  borderRadius: "50%",
                  background: "rgba(46,125,94,0.1)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 1.5rem",
                }}
              >
                <CheckIcon />
              </div>
              <div
                style={{
                  fontFamily: "'Playfair Display', serif",
                  fontSize: "1.5rem",
                  color: "rgba(10,46,82,1)",
                  marginBottom: "0.75rem",
                }}
              >
                Thank you for your input
              </div>
              <p
                style={{
                  fontSize: "0.9rem",
                  color: "#3d4f5c",
                  lineHeight: 1.6,
                  maxWidth: 360,
                  margin: "0 auto",
                }}
              >
                Your feedback has been recorded and will help improve the IPPIS
                system for all users across Rwanda.
              </p>
            </div>
          ) : (
            <>
              {/* ── Step label ── */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  marginBottom: "1.75rem",
                }}
              >
                <div
                  style={{
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    background: "#c9973a",
                    flexShrink: 0,
                  }}
                />
                <span
                  style={{
                    fontSize: "0.75rem",
                    fontWeight: 500,
                    textTransform: "uppercase",
                    letterSpacing: "0.08em",
                    color: "#8fa0ad",
                  }}
                >
                  {step === 0
                    ? "Your profile"
                    : `Question ${step} of ${questions.length}`}
                </span>
              </div>
              {step === 0 && (
                <>
                  {/* Intro note */}
                  <p
                    style={{
                      fontSize: "0.9rem",
                      color: "#3d4f5c",
                      lineHeight: 1.65,
                      marginBottom: "2rem",
                      padding: "1rem 1.25rem",
                      background: "#f5e9d0",
                      borderLeft: "3px solid #c9973a",
                      borderRadius: "0 8px 8px 0",
                    }}
                  >
                    MIFOTRA is conducting an evaluation of the IPPIS system.
                    Kindly contribute to its enhancement by sharing your
                    experience with the module you use most.
                  </p>

                  {/* Phone number */}
                  <div style={{ marginBottom: "1.25rem" }}>
                    <label
                      style={{
                        display: "block",
                        fontSize: "0.78rem",
                        fontWeight: 500,
                        textTransform: "uppercase",
                        letterSpacing: "0.07em",
                        color: "#3d4f5c",
                        marginBottom: "0.45rem",
                      }}
                    >
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      placeholder="0788000000"
                      value={form.phone}
                      onChange={(e) => handleChange("phone", e.target.value)}
                      style={{
                        width: "100%",
                        padding: "0.75rem 1rem",
                        fontFamily: "'DM Sans', sans-serif",
                        fontSize: "0.95rem",
                        color: "rgba(10,46,82,1)",
                        background: "#faf8f5",
                        border: "1.5px solid #dde3e8",
                        borderRadius: 10,
                        outline: "none",
                        boxSizing: "border-box",
                      }}
                    />
                  </div>

                  {/* Position + Institution side by side */}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "1rem",
                    }}
                  >
                    <div style={{ marginBottom: "1.25rem" }}>
                      <label
                        style={{
                          display: "block",
                          fontSize: "0.78rem",
                          fontWeight: 500,
                          textTransform: "uppercase",
                          letterSpacing: "0.07em",
                          color: "#3d4f5c",
                          marginBottom: "0.45rem",
                        }}
                      >
                        Job Position
                      </label>
                      <input
                        value={form.position}
                        disabled
                        placeholder="Auto-filled"
                        style={{
                          width: "100%",
                          padding: "0.75rem 1rem",
                          fontFamily: "'DM Sans', sans-serif",
                          fontSize: "0.95rem",
                          color: "rgba(10,46,82,1)",
                          background: "#faf8f5",
                          border: "1.5px solid #dde3e8",
                          borderRadius: 10,
                          outline: "none",
                          boxSizing: "border-box",
                          opacity: 0.55,
                          cursor: "not-allowed",
                        }}
                      />
                    </div>
                    <div style={{ marginBottom: "1.25rem" }}>
                      <label
                        style={{
                          display: "block",
                          fontSize: "0.78rem",
                          fontWeight: 500,
                          textTransform: "uppercase",
                          letterSpacing: "0.07em",
                          color: "#3d4f5c",
                          marginBottom: "0.45rem",
                        }}
                      >
                        Institution
                      </label>
                      <input
                        value={form.institution}
                        disabled
                        placeholder="Auto-filled"
                        style={{
                          width: "100%",
                          padding: "0.75rem 1rem",
                          fontFamily: "'DM Sans', sans-serif",
                          fontSize: "0.95rem",
                          color: "rgba(10,46,82,1)",
                          background: "#faf8f5",
                          border: "1.5px solid #dde3e8",
                          borderRadius: 10,
                          outline: "none",
                          boxSizing: "border-box",
                          opacity: 0.55,
                          cursor: "not-allowed",
                        }}
                      />
                    </div>
                  </div>

                  {/* Module dropdown */}
                  <div style={{ marginBottom: "1.25rem" }}>
                    <label
                      style={{
                        display: "block",
                        fontSize: "0.78rem",
                        fontWeight: 500,
                        textTransform: "uppercase",
                        letterSpacing: "0.07em",
                        color: "#3d4f5c",
                        marginBottom: "0.45rem",
                      }}
                    >
                      Most Used IPPIS Module
                    </label>
                    <div style={{ position: "relative" }}>
                      <select
                        value={form.module}
                        onChange={(e) => handleChange("module", e.target.value)}
                        style={{
                          width: "100%",
                          padding: "0.75rem 1rem",
                          fontFamily: "'DM Sans', sans-serif",
                          fontSize: "0.95rem",
                          color: "rgba(10,46,82,1)",
                          background: "#faf8f5",
                          border: "1.5px solid #dde3e8",
                          borderRadius: 10,
                          outline: "none",
                          appearance: "none",
                          boxSizing: "border-box",
                          cursor: "pointer",
                        }}
                      >
                        <option value="">Select a module…</option>
                        {modules.map((m) => (
                          <option key={m.id} value={m.categoryName}>
                            {m.categoryName}
                          </option>
                        ))}
                      </select>
                      <span
                        style={{
                          position: "absolute",
                          right: 14,
                          top: "50%",
                          transform: "translateY(-50%)",
                          pointerEvents: "none",
                          width: 0,
                          height: 0,
                          borderLeft: "5px solid transparent",
                          borderRight: "5px solid transparent",
                          borderTop: "5px solid #8fa0ad",
                        }}
                      />
                    </div>
                  </div>
                </>
              )}

              {/* ── Step 1+: Question + textarea ── */}
              {step > 0 && (
                <>
                  <div
                    style={{
                      fontFamily: "'Playfair Display', serif",
                      fontSize: "1.2rem",
                      color: "rgba(10,46,82,1)",
                      fontWeight: 500,
                      lineHeight: 1.5,
                      marginBottom: "1.5rem",
                    }}
                  >
                    {questions[step - 1].replace("module-X", moduleName)}
                  </div>
                  <textarea
                    placeholder="Share your thoughts here…"
                    value={form.answers[step - 1]}
                    onChange={(e) => handleAnswerChange(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "0.75rem 1rem",
                      fontFamily: "'DM Sans', sans-serif",
                      fontSize: "0.95rem",
                      color: "rgba(10,46,82,1)",
                      background: "#faf8f5",
                      border: "1.5px solid #dde3e8",
                      borderRadius: 10,
                      outline: "none",
                      resize: "vertical",
                      minHeight: 130,
                      lineHeight: 1.6,
                      boxSizing: "border-box",
                    }}
                  />
                </>
              )}

              {/* ── Footer: Back / counter / Next ── */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: "2rem",
                  paddingTop: "1.5rem",
                  borderTop: "1px solid #dde3e8",
                }}
              >
                <button
                  disabled={step === 0}
                  onClick={back}
                  style={{
                    fontFamily: "'DM Sans', sans-serif",
                    fontSize: "0.9rem",
                    fontWeight: 500,
                    color: "#8fa0ad",
                    background: "none",
                    border: "none",
                    cursor: step === 0 ? "not-allowed" : "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.4rem",
                    padding: "0.5rem 0",
                    opacity: step === 0 ? 0.3 : 1,
                  }}
                >
                  <ArrowLeft /> Back
                </button>

                <span
                  style={{
                    fontSize: "0.78rem",
                    color: "#8fa0ad",
                    letterSpacing: "0.04em",
                  }}
                >
                  {step}/{questions.length}
                </span>

                {step < questions.length ? (
                  <button
                    onClick={next}
                    disabled={step === 0 && !canProceedProfile}
                    style={{
                      fontFamily: "'DM Sans', sans-serif",
                      fontSize: "0.92rem",
                      fontWeight: 500,
                      padding: "0.7rem 1.75rem",
                      border: "none",
                      borderRadius: 10,
                      cursor:
                        step === 0 && !canProceedProfile
                          ? "not-allowed"
                          : "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      background: "rgba(10,46,82,1)",
                      color: "#ffffff",
                      letterSpacing: "0.02em",
                      opacity: step === 0 && !canProceedProfile ? 0.35 : 1,
                    }}
                  >
                    Next <ArrowRight />
                  </button>
                ) : (
                  <button
                    onClick={handleSubmit}
                    style={{
                      fontFamily: "'DM Sans', sans-serif",
                      fontSize: "0.92rem",
                      fontWeight: 500,
                      padding: "0.7rem 1.75rem",
                      border: "none",
                      borderRadius: 10,
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      background: "#2e7d5e",
                      color: "#ffffff",
                      letterSpacing: "0.02em",
                    }}
                  >
                    Submit <ArrowRight />
                  </button>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default function SurveyInterviewQuestionFormExport() {
  return <SurveyInterviewQuestionForm />;
}
